import React, { type ReactNode } from "react";
import { twMerge } from "tailwind-merge";

import { SupText } from "../../../../components/UI/Text";

interface THeadProps {
  title: ReactNode;
  className?: string;
  width?: number;
  minWidth?: number;
  maxWidth?: number;
  align?: "left" | "right" | "center";
}

export function THead({ title, className, width, minWidth, maxWidth, align }: THeadProps) {
  return (
    <SupText
      as="th"
      className={twMerge("sup-table-th text-left h-14 first-of-type:pl-4 last-of-type:pr-4", className)}
      variant="subtitle1"
      style={{ width, minWidth, maxWidth, textAlign: align }}
    >
      {title}
    </SupText>
  );
}
